import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import Icon from '../icons/Icon';

const SortableItem = SortableElement(({ value }) => (
  <li>
    <div className="admin-paper__list__title">
      <Icon icon="DragHandle" />
      {value}
    </div>
  </li>
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className="admin-paper__list">
      {items.map((value, index) => <SortableItem key={`item-${index}`} index={index} value={value.name} />)}
    </ul>
  );
});

class SortableComponent extends Component {
  static propTypes = {
    items: PropTypes.array,
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.onSortEnd(arrayMove(this.props.items, oldIndex, newIndex));
  };

  render() {
    return <SortableList items={this.props.items} onSortEnd={this.onSortEnd} />;
  }
}

export default SortableComponent;



// WEBPACK FOOTER //
// ./src/common/components/SortableComponent.js